import Image from 'next/image'
import { tm } from '@captaincause/ui/tm'
import { flattenImages } from 'utils/strapi/image'
import { Button } from 'components/Button'
import { StrapiImage } from 'components/StapiImage'
import type { StaticImageData } from 'next/image'
import type { StrapiApiImages } from 'types/strapi/image'
import type { StrapiLink } from 'types/strapi/link'

type LocalLogo = {
  image: StaticImageData
  alt: string
}

type ExternalLogo = StrapiApiImages

export interface LogosProps {
  title?: string
  description?: string
  link?: StrapiLink
  images?: LocalLogo[] | ExternalLogo
}

export default function Logos({
  title = '',
  description = '',
  link = undefined,
  images: propsLogos = undefined,
}: LogosProps) {
  const logos =
    propsLogos && 'data' in propsLogos ? flattenImages(propsLogos) : propsLogos

  return (
    <div className="mx-auto h-auto w-full max-w-[1400px] overflow-hidden bg-white px-4 py-10 md:px-8 md:py-16">
      <div
        className={tm(
          'mb-8 flex flex-col flex-wrap items-center justify-center',
          link && ' justify-between md:flex-row',
        )}
      >
        {title ? (
          <h2 className="order-2 mb-4 block max-w-4xl text-center font-default text-3xl font-semibold leading-8 -tracking-[1.5px] md:order-[unset]">
            {title}
          </h2>
        ) : null}
        {description ? (
          <p className="order-2 block max-w-4xl text-center font-default text-base font-normal leading-8 text-dark-gray md:text-[18px]">
            {description}
          </p>
        ) : null}

        {link ? (
          <Button
            variant="secondary"
            iconRight="arrow-go"
            href={link.url}
            className="order-1 mb-4 w-full md:order-[unset] md:w-[unset]"
          >
            {link.title}
          </Button>
        ) : null}
      </div>
      <div className="flex max-w-7xl flex-wrap items-center justify-center gap-x-14 gap-y-6 md:gap-x-20">
        {logos?.map(logo => {
          if (!logo) return null
          if ('url' in logo) {
            return (
              <StrapiImage
                key={logo.name}
                className="h-max max-h-[60px] w-max max-w-[100px] object-contain md:max-w-[140px]"
                {...logo}
              />
            )
          }

          return (
            <Image
              key={logo.alt}
              src={logo.image}
              height={72}
              alt={logo.alt}
              className="h-max max-h-[60px] w-max max-w-[100px] object-contain md:max-w-[140px]"
            />
          )
        })}
      </div>
    </div>
  )
}
